// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"149":"3b54b811fd7e8521","191":"aecc45bb8bdc1577","244":"ff35acff4471840b","245":"35e093e6dffa359a","451":"82385130f21f7e79","453":"5c29eb006f59e81e","569":"41e44d2b577b8cb2","664":"807c6daecd1559d3","710":"8831da4516737558","714":"7ffb22312dba904f"}[chunkId] + ".js";
};